module.exports = __webpack_public_path__ + "static/media/teke-letame.91f97e7e.jpg";